import { saveWebCookie, webCookie } from "@/lib/cookies";

const $cadDropdownListe = $("#cadenasformat");
const $weitereCadFormateToggleElement = $("#weitere-formate.toggle");
const $weitereCadFormateDetailsToggle = $("#cad-format-accordion");
const isClosedToggleState = "is-closed";
const $cadStdButton = $("#cad_std_button");
const $selectedCadFormat = $("#selectedCadFormat");
const $cadAngemeldetAlsEmailButton = $("#cad_angemeldet_email_button");

$(() => {
	// Das vorausgewählte Cad-Format entspricht dem zuletzt ausgewählten Format.
	// Deswegen nach dem Laden des DOMs die Funktion durchführen, damit die Buttons korrekt gesetzt werden.
	cadSelectionChanged();

	// Beim Laden der Seite muss das CAD-Toggle Element in den richtigen Zustand gebracht werden.
	if ($weitereCadFormateToggleElement.length) {
		weitereFormateToggleStateStatusSetzen();
	}
});

$cadDropdownListe.on("change", cadSelectionChanged);

function cadSelectionChanged() {
	if (!$cadDropdownListe.length) return;

	const selectedItem = $cadDropdownListe.find(":selected");
	const keinFormatGewaehlt = selectedItem.data("no-format-selected") as boolean ?? false;
	const value = selectedItem.attr("value") as string;

	$selectedCadFormat.val(value);

	toggleCadButtons(keinFormatGewaehlt);

	if (webCookie.values) {
		webCookie.values.CadFormat = value;
		saveWebCookie();
	}
}

function toggleCadButtons(keinFormatGewaehlt: boolean) {
	let disabled = keinFormatGewaehlt ? "true" : null;

	$cadStdButton.add($cadAngemeldetAlsEmailButton)
		.prop("disabled", disabled);
}

// Der Button, der in der CAD-Download-From das Submit ausgelöst hat,
// wird mit einem händisch hinzugefügten "clicked"-Attribut gekennzeichnet
// https://stackoverflow.com/questions/5721724/jquery-how-to-get-which-button-was-clicked-upon-form-submission (27.05.19)
$("#cad-download input[type=submit]").on("click", e => {
	$("input[type=submit]", $(e.currentTarget).parents("form")).removeAttr("clicked");
	$(e.currentTarget).attr("clicked", "true");
});

// Im Cookie wird der ToggleState gespeichert
// Durch die Umstrukturierung (GKS-1908) des CAD-Download bereichts, ist die Anmeldung und Formatauswahl in einem Toggle-Element.
// Nach der Anmeldung wird die Seite refreshed und das Toggle-Element soll weiterhin geöffnet bleiben.
$weitereCadFormateToggleElement.on("click", () => {
	// Die CSS-Klasse "is-closed" wird erst nach dem click-Event von re-lounge entfernt.
	// Deswegen muss der ToggleState Open im Cookie auf "True" gesetzt werden, wenn das Element die Klasse "is-closed" noch besitzt.
	// Umgekehrt muss der ToggleState Open im Cookie auf "False" gesetzt werden, wenn das Element die Klasse "is-closed" NICHT besitzt.
	if (webCookie.values) {
		webCookie.values.CadWeitereFormateToggleStateIsOpen = $weitereCadFormateToggleElement.hasClass(isClosedToggleState);
		saveWebCookie();
	}
});

function weitereFormateToggleStateStatusSetzen() {
	if (webCookie.values) {
		if (webCookie.values.CadWeitereFormateToggleStateIsOpen) {
			$weitereCadFormateToggleElement.removeClass(isClosedToggleState);
			$weitereCadFormateDetailsToggle.attr("open", "open");
		} else {
			$weitereCadFormateToggleElement.addClass(isClosedToggleState);
			$weitereCadFormateDetailsToggle.removeAttr("open");
		}
	}
}
